export default __webpack_public_path__ + "images/2550b13d0841d4f1047f305d03b48b28.png";